export const PROFILE_IMAGE_WHILE_SIGNUP_LABEL_ID = 'aaaaaa';
export const PROFILE_IMAGE_WHILE_PROFILE_EDIT_LABEL_ID = 'aaaaab';
export const PROFILE_CV_WHILE_SIGNUP_LABEL_ID = 'aaaaac';
export const PROFILE_CV_WHILE_PROFILE_EDIT_LABEL_ID = 'aaaaad';
export const HOMEPAGE_JOBSEEKERS_SECTION_ID = "aaaaae";
export const INTERVIEW_CONSENT_PAGE_VIDEO_PREVIEW_ELEMENT = "aaaaaf";